import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import useStyles from '../../styles/useStyles';

export const DeleteDataCell: React.FC<any> = ({ props, setDataItemForDelete, setVisible, visible }) => {
    const classes = useStyles();
    return (
        <div className={`${classes.root} ${classes.buttonGridAction}`} title="Remove">
            <Button
                variant='contained'
                color='secondary'
                size='small'
                className={classes.deleteButton}
                onClick={(e) => {
                    setDataItemForDelete(props.dataItem);
                    setVisible(!visible);
                }}
            >
                <DeleteIcon className={classes.deleteButtonIcon} />
            </Button>
        </div>
    );
};